// Sprint Action Types
export const ADD_SPRINT_REQUEST = "ADD_SPRINT_REQUEST";
export const ADD_SPRINT_SUCCESS = "ADD_SPRINT_SUCCESS";
export const ADD_SPRINT_FAIL = "ADD_SPRINT_FAIL";

export const GET_SPRINTS_REQUEST = "GET_SPRINTS_REQUEST";
export const GET_SPRINTS_SUCCESS = "GET_SPRINTS_SUCCESS";
export const GET_SPRINTS_FAIL = "GET_SPRINTS_FAIL";

export const GET_SPRINT_TASKS_REQUEST = "GET_SPRINT_TASKS_REQUEST";
export const GET_SPRINT_TASKS_SUCCESS = "GET_SPRINT_TASKS_SUCCESS";
export const PUSH_SPRINT_TASKS_SUCCESS = "PUSH_SPRINT_TASKS_SUCCESS";
export const GET_SPRINT_TASKS_FAIL = "GET_SPRINT_TASKS_FAIL";

export const UPDATE_SPRINT_COMPLETE_STATUS = "UPDATE_SPRINT_COMPLETE_STATUS";

export const PUSH_ARCHIVED_SPRINTS = "PUSH_ARCHIVED_SPRINTS";
export const RESET_ARCHIVED_SPRINTS = "RESET_ARCHIVED_SPRINTS";
